export default "__VITE_ASSET__BTG3ZbY5__"